import React from "react"
import { getTranslationMessages } from "../../app/localization/translations-store"

// localize(id, defaultMessage, html?)
export function localize(id, arg2 = false, arg3 = false) {
	const messages = getTranslationMessages()
	const defaultMessage = typeof arg2 === "string" ? arg2 : undefined
	const html = typeof arg2 === "boolean" ? arg2 : !!arg3

	const message = (messages && messages[id]) || defaultMessage || id

	if (html) {
		// eslint-disable-next-line react/no-danger
		return <div dangerouslySetInnerHTML={{ __html: message }} />
	}

	return message
}
